var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { TextInputField } from '@/components';
export var ScriptConfigurationPanel = function (_a) {
    var configuration = _a.configuration, setConfiguration = _a.setConfiguration;
    var formRef = useRef(null);
    var handleUpdateInput = function (e) {
        var _a = e.target, key = _a.name, value = _a.value;
        setConfiguration(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = value, _a)));
        });
    };
    return (_jsx("div", { className: 'p-4 rounded-lg border', children: _jsx("form", { ref: formRef, children: _jsx("div", { className: 'grid w-full gap-2 text-sm', children: _jsxs("div", { className: 'grid grid-cols-1 sm:grid-cols-3 gap-2', children: [_jsx(TextInputField, { label: 'Api Base URL', name: 'apiBaseUrl', value: configuration.apiBaseUrl, onChange: handleUpdateInput, placeholder: 'https://api.example.com', required: true, isRequired: true }), _jsx(TextInputField, { label: 'Token Key', tooltip: "Specify the location of the token. For example, use 'cookies.token' if the token is stored in cookies, or 'localStorage.token' if it is stored in local storage.", name: 'tokenKey', value: configuration.tokenKey, onChange: handleUpdateInput, placeholder: 'localhost.token', required: true, isRequired: true })] }) }) }) }));
};
